import React, { useState, useEffect } from "react";
// import './AdminSidebar.css'
import logo from "./logo.png";
import dash from "./dash.png";
import dashActive from "./dash-active.png";
import student from "./student.png";
import studentActive from "./student-active.png";
import summary from "./summary.png";
import report from "./reports.png";
import summaryActive from "./summary-active.png";
import performance from "./performance.png";
import performanceActive from "./performanceActive.png";
import { useNavigate, useLocation } from "react-router-dom";
import "./AdminSidebar.css";

const TeacherSidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [selectedItem, setSelectedItem] = useState("");

    useEffect(() => {
        // Get the current path and set it as selected item
        const path = location.pathname.split("/")[1] || "AdminDashHandle";
        // const path = "AdminDashHandle";
        setSelectedItem(path);
    }, [location.pathname]);

    const onClick = (route) => {
        setSelectedItem(route);
        navigate(`/${route}`);
    };

    useEffect(() => {
        console.log("selectedItem >>>>>>>> ", selectedItem);
    }, [selectedItem]);

    // Menu items data for cleaner code
    const menuItems = [
        {
            route: [ "adminDashboard"],
            name: "Dashboard",
            icon: dash,
            activeIcon: dashActive,
        },
        {
            route: ["StudentListadmin", "AdminStudentPerformance"],
            name: "Student",
            icon: student,
            activeIcon: studentActive,
        },
        {
          route: ["AdminSummary"],
          name: "SuccessFactor",
          icon: performance,
          activeIcon: summaryActive
        },
        // {
        //   route: ["AdminReport"],
        //   name: "Report",
        //   icon: performance,
        //   activeIcon: summaryActive
        // },
        // {
        //   route: "TeacherCourseList",
        //   name: "Course",
        //   icon: summary,
        //   activeIcon: summaryActive
        // }
        {
            route: ["AdminProfile"],
            name: "Profile",
            icon: summary,
            activeIcon: performanceActive,
        },
    ];
    // const menuItems = [
    //     {
    //         route: "adminDashboard",
    //         name: "Dashboard",
    //         icon: dash,
    //         activeIcon: dashActive,
    //     },
    //     {
    //         route: "StudentListadmin",
    //         name: "Student",
    //         icon: student,
    //         activeIcon: studentActive,
    //     },
    //     // {
    //     //   route: "Teacherprojects",
    //     //   name: "Projects",
    //     //   icon: summary,
    //     //   activeIcon: summaryActive
    //     // },
    //     // {
    //     //   route: "CourseProgress",
    //     //   name: "Course",
    //     //   icon: summary,
    //     //   activeIcon: summaryActive
    //     // },
    //     // {
    //     //   route: "TeacherCourseList",
    //     //   name: "Course",
    //     //   icon: summary,
    //     //   activeIcon: summaryActive
    //     // }
    //     {
    //         route: "AdminProfile",
    //         name: "Profile",
    //         icon: performance,
    //         activeIcon: performanceActive,
    //     },
    // ];

    return (
        <div className="adminSidebarMain">
            <div className="adminSidebarLogo">
                <img src={logo} alt="Logo" />
            </div>
            <div className="adminSidebarPartition"></div>
            <div className="adminSidebarLinks">
                {/* Highlight background for active item */}
                <div
                    className="sidebarButtonBg"
                    style={{
                        transform: `translateY(${
                            menuItems.findIndex(
                                (item) => item.route.includes(selectedItem) 
                            ) * 50
                        }px)`,
                        // transform: "translateY(-50px)",
                        opacity: selectedItem ? 1 : 0,
                    }}
                ></div>

                <div className="adminLinksContainer">
                    {menuItems.map((item, index) => (
                        <div
                            key={item.route}
                            className={`Link ${
                                item.route.includes(selectedItem) ? "activeLink" : ""
                            }`}
                            onClick={() => onClick(item.route[0])}
                        >
                            <img
                                src={
                                    item.route.includes(selectedItem)
                                        ? item.activeIcon
                                        : item.icon
                                }
                                alt={item.name}
                            />
                            {item.name}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default TeacherSidebar;
